// Normalise un nom de région
// Exemple :
// BOENY => boeny
// Boeny => boeny
// Atsimo-Andrefana => atsimoandrefana

import { REGION_COORDS } from '../Coordone'

export function normalizeRegionName(name) {
    if (!name) return ''

    return name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[-']/g, '')
        .replace(/\s+/g, '')
        .toLowerCase()
}

// Retourne les coordonnées d'une région
// peu importe la casse, accent, tiret...

export function getRegionCoords(regionName) {
    const normalizedName = normalizeRegionName(regionName)

    const key = Object.keys(REGION_COORDS).find((region) => normalizeRegionName(region) === normalizedName)

    return key ? REGION_COORDS[key] : null
}
